export const DOCTOR_REF_STORAGE_KEY = 'doctor_ref'
